import { CharacterBase, COOLDOWN_KNOCKDOWN, COOLDOWN_RESTRAINT } from '../CharacterBase';

export class CharacterStateMachine {
  constructor(scene, character) {
    this._scene = scene;
    this._character = character;
    this._prevState = false;
    this._state = CharacterBase.STATES.IDLE;
    this._stateDuration = 0;
  }

  get scene() {
    return this._scene;
  }

  get state() {
    return this._state;
  }

  get previousState() {
    return this._prevState;
  }

  get stateDuration() {
    return this._stateDuration;
  }

  get character() {
    return this._character;
  }

  isState(state) {
    if (Array.isArray(state)) {
      return state.includes(this._state) ? true : false;
    }
    return this._state === state;
  }

  setState(state, force) {
    if (this._state === state && !force) return;
    if (this._state != state) this._prevState = this._state;
    this._state = state;
    this._stateDuration = 0;
  }

  setPreviousState() {
    if (this._prevState) this.setState(this._prevState);
  }

  update(delta) {
    this._stateDuration += delta;
    if (this[this._state]) this[this._state](delta);
  }

  // =============================================================================================
  // STATE UPDATES - INTENDED FOR INTERNAL PURPOSES ONLY
  // =============================================================================================

  idle(delta) {
    this.character.updateMovement(delta);

    if (this.character.isJumping) {
    } else {
      if (Math.abs(this.character.velocity.x) + Math.abs(this.character.velocity.y) === 0) {
        this.character.playAnimation(CharacterBase.ANIMATIONS.IDLE, true);
      } else {
        this.character.playAnimation(CharacterBase.ANIMATIONS.WALK, true);
      }
    }
  }

  jumpstart(delta) {
    this.character.updateMovement(delta);
  }

  attack(delta) {
    // there is no active attack to update, go idle
    if (!this.character.activeAttack) return this.character.setIdleState();
    // update attack and check if complete
    this.character.activeAttack.update(delta);
    // update character movement
    this.character.updateMovement(delta);
    // check for completion
    if (this.character.activeAttack.complete) this.character.handleAttackComplete();
  }

  knockdown(delta) {
    if (
      this.character.bodyCollider.right > this.character.scene.viewport.right &&
      this.character.velocity.x > 0
    ) {
      this.character.velocity.x *= -1;
      this.character.velocity.z = -Math.abs(this.character.velocity.z);
    } else if (
      this.character.bodyCollider.left < this.character.scene.viewport.left &&
      this.character.velocity.x < 0
    ) {
      this.character.velocity.x *= -1;
      this.character.velocity.z = -Math.abs(this.character.velocity.z);
    }

    this.character.velocity.x *= 0.95;

    this.character.updateMovement(delta);

    if (this._stateDuration >= COOLDOWN_KNOCKDOWN && this.character.isGrounded) {
      this._stateDuration = 0;
      this.character.bodyCollider.enabled = true;
      this.character.standUp();
    }
  }

  restraint(delta) {
    if (this._stateDuration >= COOLDOWN_RESTRAINT) this.character.setIdleState();
  }

  dead(delta) {
    this.character.velocity.x = 0;
    this.character.velocity.y = 0;
    this.character.updateMovement(delta);
    if (this.character.sprite.alpha > 0) {
      this.character.sprite.alpha -= delta * 1.5;
      if (this.character.sprite.alpha <= 0) {
        this.character.emit(CharacterBase.EVENTS.DEAD, this.character);
      }
    }
  }

  thrown(delta) {
    if (this._stateDuration > 0.1) {
      if (
        this.character.bodyCollider.right > this.character.scene.viewport.right &&
        this.character.velocity.x > 0
      ) {
        this.character.velocity.x *= -1;
        this.character.velocity.z = -Math.abs(this.character.velocity.z);
      } else if (
        this.character.bodyCollider.left < this.character.scene.viewport.left &&
        this.character.velocity.x < 0
      ) {
        this.character.velocity.x *= -1;
        this.character.velocity.z = -Math.abs(this.character.velocity.z);
      }

      if (this.character.sprite.y >= 0) {
        this.character.velocity.x *= 0.9;
      } else {
        this.character.velocity.x *= 0.96;
      }
      this.character.updateMovement(delta);

      if (this.character.isGrounded && Math.abs(this.character.velocity.x) < 5) {
        this.character.bodyCollider.enabled = true;
        this.character.standUp();
      }
    }
  }

  destroy() {
    this._scene = null;
    this._character = null;
    this._prevState = null;
    this._state = null;
    this._stateDuration = null;
  }
}

export class CharacterStateMachineEnemy extends CharacterStateMachine {
  idle(delta) {
    this.character.findPathToHero();
    super.idle(delta);
    if (this.character.heroTarget) this.character.faceTarget(this.character.heroTarget);
    this.character.checkForRequestAttack(delta);
  }
}

export class CharacterStateMachineHero extends CharacterStateMachine {
  idle(delta) {
    this.character.updateComboCooldown(delta);
    this.character.updateFaceDirection(delta);
    this.character.velocity = this.character.getInputVelocity();
    super.idle(delta);
    // this.character.checkForGrab(delta);
  }

  grab() {
    const target = this.character.getGrabTarget();
    if (
      !target ||
      !target.isInState([CharacterBase.STATES.RESTRAINT, CharacterBase.STATES.DAMAGE])
    ) {
      this.character.releaseGrabTarget();
    }
  }

  demoAttack(delta) {
    super.attack(delta);
  }

  demoWalk(delta) {}

  demoJump(delta) {
    this.character.updateMovement(delta);
    if (!this.character.isJumping) this.character.demoIdle();
  }

  respawn(delta) {
    this.character.updateMovement(delta);
    if (this.character.isGrounded) this.character.setIdleState();
  }
}
